import { NgModule } from '@angular/core';
import { FormHintDirective } from './hint.directive';


@NgModule({
  declarations: [
    FormHintDirective
  ],
  exports: [
    FormHintDirective
  ]
})
export class FormHintModule {}
